/**
 * @generated SignedSource<<c945a356d6f9ddc18429822c92245039>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpsertClientNutritionEntryInput = {
  calories?: number | null | undefined;
  carbsGrams?: number | null | undefined;
  clientMutationId?: string | null | undefined;
  date: string;
  fatGrams?: number | null | undefined;
  id?: string | null | undefined;
  proteinGrams?: number | null | undefined;
  targetId: string;
};
export type ClientNutritionTargetDrawerEntryHistoryItemMutation$variables = {
  input: UpsertClientNutritionEntryInput;
};
export type ClientNutritionTargetDrawerEntryHistoryItemMutation$data = {
  readonly upsertClientNutritionEntry: {
    readonly clientNutritionEntry: {
      readonly calories: number | null | undefined;
      readonly carbsGrams: number | null | undefined;
      readonly fatGrams: number | null | undefined;
      readonly id: string;
      readonly proteinGrams: number | null | undefined;
      readonly target: {
        readonly id: string;
      };
    } | null | undefined;
  } | null | undefined;
};
export type ClientNutritionTargetDrawerEntryHistoryItemMutation = {
  response: ClientNutritionTargetDrawerEntryHistoryItemMutation$data;
  variables: ClientNutritionTargetDrawerEntryHistoryItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpsertClientNutritionEntryPayload",
    "kind": "LinkedField",
    "name": "upsertClientNutritionEntry",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientNutritionEntry",
        "kind": "LinkedField",
        "name": "clientNutritionEntry",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "carbsGrams",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "calories",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fatGrams",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "proteinGrams",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClientNutritionTarget",
            "kind": "LinkedField",
            "name": "target",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientNutritionTargetDrawerEntryHistoryItemMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientNutritionTargetDrawerEntryHistoryItemMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "9b7e6268204122b2f379df8527e3f375",
    "id": null,
    "metadata": {},
    "name": "ClientNutritionTargetDrawerEntryHistoryItemMutation",
    "operationKind": "mutation",
    "text": "mutation ClientNutritionTargetDrawerEntryHistoryItemMutation(\n  $input: UpsertClientNutritionEntryInput!\n) {\n  upsertClientNutritionEntry(input: $input) {\n    clientNutritionEntry {\n      id\n      carbsGrams\n      calories\n      fatGrams\n      proteinGrams\n      target {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9b88efeec0f6f1d5d250c37306e2ceeb";

export default node;
